export const CREATE_EXHIBITOR = `
  mutation createExhibitor($input: CreateExhibitorInput!, $createUserInput: CreateUserInput, $tenant_id: Int!) {
    createExhibitor(input: $input, createUserInput: $createUserInput, tenant_id: $tenant_id) {
      __typename
      ... on Exhibitor {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
        }
        type
        pay
        pay_virtual
        pay_virtual_short
        probono
        roaming
        roaming_provinces
        linkedin
        intergrupal
        status
        initial_month
        referred_by
        curriculum_vitae
        photo
        company_name
        cuit
        iva_condition
        bank
        bank_account_type
        branch_office
        branch_office_number
        account_holder
        cbu
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_EXHIBITOR = `
  mutation updateExhibitor($input: UpdateExhibitorInput!, $createUserInput: CreateUserInput, $tenant_id: Int!) {
    updateExhibitor(input: $input, createUserInput: $createUserInput, tenant_id: $tenant_id) {
      __typename
      ... on Exhibitor {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
        }
        type
        pay
        pay_virtual
        pay_virtual_short
        probono
        roaming
        roaming_provinces
        linkedin
        intergrupal
        status
        initial_month
        referred_by
        curriculum_vitae
        photo
        company_name
        cuit
        iva_condition
        bank
        bank_account_type
        branch_office
        branch_office_number
        account_holder
        cbu
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_EXHIBITOR = `
  mutation deleteExhibitor($id: Int!, $tenant_id: Int!) {
    deleteExhibitor(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on Exhibitor {
        id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_MY_EXHIBITOR_PROFILE = `
mutation updateMyExhibitorProfile($tenant_id: Int!, $input: UpdateMyExhibitorProfileInput!) {
  updateMyExhibitorProfile(tenant_id: $tenant_id, input: $input) {
    __typename
    ... on Exhibitor { id }
    ... on ResultError { status_code message message_translation_key }
  }
}`;
